module.exports = __webpack_public_path__ + "static/media/scorpio.94c66da1.svg";